import { takeEvery, put, call } from 'redux-saga/effects';

import { URL_API } from '../../common/constants/common.js';
import { HttpConnection } from '../../common/helper/http-connection.js'
import { loginCheck, maintenanceCheck } from '../../common/helper/commonHelper.js';

function* getCourseInfo(action) {
    if(yield call(maintenanceCheck)){
        if(action.onFailure) {
            action.onFailure("403", "maintenance...");
        }
        return;
    }
    let http = new HttpConnection();
    let info = {
        url: URL_API + '/getCourseInfo',
        parameter: {
        },
    }
    const data = yield call(http.get, info);

    if(data.statusCode === 200){
        let course = [];
        for(let key in data.course){
            course[data.course[key].id] = {
                    name: data.course[key].name,
                    sendMax: data.course[key].sendMax,
                    sendValid: data.course[key].sendValid,
            };
        }
        yield put({
            type: "Course",
            course: course
        });
        if(action.onSuccess) {
            action.onSuccess(course);
        }
    } else {
        yield put({
            type: "ErrorInfo",
            source: "getCourseInfo",
            statusCode: data.statusCode,
            error: data.error,
        });
        if(action.onFailure) {
            action.onFailure(data.statusCode, data.error);
        }
    }
}

export const getCourseInfoSaga = takeEvery('GetCourseInfo_Saga', getCourseInfo);

function* uploadAudio(action) {
    if(yield call(maintenanceCheck)){
        if(action.onFailure) {
            action.onFailure("403", "maintenance...");
        }
        return;
    }
    yield call(loginCheck);
    let http = new HttpConnection();
    let info = {
        url: URL_API + '/uploadAudio',
        parameter: {
            id: action.id,
            subjectID: action.subjectID,
            mode: action.mode,
            name: action.name,
            audio: action.audio
        },
    }
    const data = yield call(http.post, info);

    if(data.statusCode === 200){
        if(action.onSuccess) {
            action.onSuccess();
        }
    } else {
        yield put({
            type: "ErrorInfo",
            source: "uploadAudio",
            statusCode: data.statusCode,
            error: data.error,
        });
        if(action.onFailure) {
            action.onFailure(data.statusCode, data.error);
        }
    }
}

export const uploadAudioSaga = takeEvery('UploadAudio_Saga', uploadAudio);

function* downloadAudio(action) {
    if(yield call(maintenanceCheck)){
        if(action.onFailure) {
            action.onFailure("403", "maintenance...");
        }
        return;
    }
    yield call(loginCheck);
    let http = new HttpConnection();
    let info = {
        url: URL_API + '/downloadAudio',
        parameter: {
            subjectID: action.subjectID,
            name: action.name,
            mode: action.mode,
        },
    }
    const data = yield call(http.post, info);

    if(data.statusCode === 200){
        if(action.onSuccess) {
            action.onSuccess(data.audio, action.id);
        }
    } else {
        yield put({
            type: "ErrorInfo",
            source: "downloadAudio",
            statusCode: data.statusCode,
            error: data.error,
        });
        if(action.onFailure) {
            action.onFailure(data.statusCode, data.error);
        }
    }
}

export const downloadAudioSaga = takeEvery('DownloadAudio_Saga', downloadAudio);

function* checkMaintenance(action) {
    yield call(loginCheck);
    let http = new HttpConnection();
    let info = {
        url: URL_API + '/checkMaintenance',
        parameter: {
        },
    }
    let data = yield call(http.get, info);
    if(data.statusCode === 200){
        localStorage.setItem("Maintenance", false);
        localStorage.setItem("Between", "");
        return 0;
    } else {
        localStorage.setItem("Maintenance", true);
        localStorage.setItem("Between", data.between);
        return 1;
    }
}

export const checkMaintenanceSaga = takeEvery('CheckMaintenance_Saga', checkMaintenance);

function* uploadPictureEn(action) {
    if(yield call(maintenanceCheck)){
        if(action.onFailure) {
            action.onFailure("403", "maintenance...");
        }
        return;
    }
    yield call(loginCheck);
    let http = new HttpConnection();
    let info = {
        url: URL_API + '/uploadPictureEn',
        parameter: {
            subjectID: action.subjectID,
            name: action.name,
            pictureEn: action.pictureEn
        },
    }
    const data = yield call(http.post, info);

    if(data.statusCode === 200){
        if(action.onSuccess) {
            action.onSuccess();
        }
    } else {
        yield put({
            type: "ErrorInfo",
            source: "uploadPictureEn",
            statusCode: data.statusCode,
            error: data.error,
        });
        if(action.onFailure) {
            action.onFailure(data.statusCode, data.error);
        }
    }
}

export const uploadPictureEnSaga = takeEvery('UploadPictureEn_Saga', uploadPictureEn);

function* downloadPictureEn(action) {
    if(yield call(maintenanceCheck)){
        if(action.onFailure) {
            action.onFailure("403", "maintenance...");
        }
        return;
    }
    yield call(loginCheck);
    let http = new HttpConnection();
    let info = {
        url: URL_API + '/downloadPictureEn',
        parameter: {
            name: action.name,
            subjectID: action.subjectID,
        },
    }
    const data = yield call(http.post, info);

    if(data.statusCode === 200){
        if(action.onSuccess) {
            action.onSuccess(data.pictureEn, action.id);
        }
    } else {
        yield put({
            type: "ErrorInfo",
            source: "downloadPictureEn",
            statusCode: data.statusCode,
            error: data.error,
        });
        if(action.onFailure) {
            action.onFailure(data.statusCode, data.error);
        }
    }
}

export const downloadPictureEnSaga = takeEvery('DownloadPictureEn_Saga', downloadPictureEn);
